<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <div class="modal-header">
        <h2>Thêm NCC</h2>
        <button @click.self="$emit('close')">✖</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="">Tên NCC </label>
          <input
            v-model="form.name"
            :class="error.name ? 'error' : ''"
            type="text"
            placeholder="Nhập tên NCC..."
            @input="delete error.name"
          />
          <span v-if="error.name" class="error-message">
            {{ error.name }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Điện thoại</label>
          <input
          v-model="form.phone"
          :class="error.phone ? 'error' : ''"
           type="tel"
            placeholder="Nhập sdt..." 
            @input="delete error.phone"
            />
            <span v-if="error.phone" class="error-message">
            {{ error.phone }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Địa chỉ</label>
          <input v-model="form.address" type="text" placeholder="Nhập địa chỉ..." />
          <span v-if="error.address" class="error-message">
            {{ error.address }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Email</label>
          <input v-model="form.email" type="email" placeholder="Nhập Email..." />
          <span v-if="error.email" class="error-message">
            {{ error.email }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Nhóm NCC</label>
          <input v-model="form.nhom_ncc" type="text" placeholder="VD: Hàng New, Linh kiện..." />
          <span v-if="error.nhom_ncc" class="error-message">
            {{ error.nhom_ncc }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Ghi chú</label>
          <input v-model="form.ghi_chu" type="text" />
          <span v-if="error.ghi_chu" class="error-message">
            {{ error.ghi_chu }}
          </span>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-save" @click="handleSave">Lưu</button>
        <button @click.self="$emit('close')">Huỷ</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useToast } from "@/composables/useToast";
import { supplierApi } from "@/services/api";
import { reactive, ref } from "vue";

const toast = useToast();
const emit = defineEmits(["close", "save"]);
const loading = ref(false);
const error = ref({});
const initialForm = ref({
  name: "",
  phone: "",
  address: "",
  email: "",
  nhom_ncc: "",
  no_can_tra: 0,
  ghi_chu: "",
  trang_thai: true,
});
const form = reactive({ ...initialForm.value });

const validateForm = () => {
  error.value = {};
  let isValid = true;
  if (!form.name) {
    error.value.name = "Vui lòng nhập tên nhà cung cấp";
    isValid = false;
  }
  if (!form.phone) {
    error.value.phone = "Vui lòng nhập số điện thoại";
    isValid = false;
  }
  if (form.phone) {
    const cleanPhone = form.phone.replace(/[^0-9+]/g, "");
    const phoneRegex = /^(0|84|(\+84))(3|5|7|8|9)[0-9]{8}$/;
    if (!phoneRegex.test(cleanPhone)) {
      error.value.phone = "Số điện thoại không đúng định dạng (10 số)";
      isValid = false;
    } else {
      form.phone = cleanPhone;
    }
  }

  return isValid;
};
const handleSave = async () => {
  const formData = new FormData();
  Object.keys(form).forEach((key) => {
    let value = form[key];
    if (value === null || value === undefined) value = "";
    if (typeof value === "boolean") value = value ? 1 : 0;
    formData.append(key, value);
  });
  if (validateForm()) {
    loading.value = true;
    try {
      await supplierApi.createNewSupplier(formData);
      toast.success("Thêm mới nhà cung cấp thành công");
      emit("save");
    } catch (error) {
      if (error.response && error.response.status === 422) {
        error.value = error.response.data.errors;
      }
      const errorMessage = error.response.data.error || "Lỗi khi thêm sản phẩm";
      toast.error(errorMessage);
    } finally {
      loading.value = false;
    }
  }
};
</script>
<style scoped>
.form-group {
  margin: 10px 0;
}
</style>
